import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useExperimentBucket } from '@carvana/experiment';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useContext, useRef } from 'react';
import { PrimaryButton } from '@/Button';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useSearchRequestId } from '~/contexts/InventoryContext';
import ModalContext from '~/contexts/ModalContext';
import UserContext from '~/contexts/UserContext';
import SimilarResultsSection from './SimilarResults/SimilarResultsSection';
import {
  CtaWrapper,
  NoResultsWrapper,
  NotifyButton,
  SubTitle,
  Title
} from '../ResultSearchRedesign/ZeroResultSearch.styles';
import useHeaderAccountModal from '../useHeaderAccountModal';

export default function ZeroResultsSection() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setCreateSavedSearchOpen } = useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);
  const experimentBucket = useExperimentBucket('srch-set-reduction2');
  const searchRequestId = useSearchRequestId();

  const openModal = () => {
    setCreateSavedSearchOpen(true, appliedFilters);
  };
  const successHandler = async () => {
    triggerFetchUserProfile();
    setCreateSavedSearchOpen(true, appliedFilters);
  };
  const handleOpenModal = useHeaderAccountModal({
    openModal,
    successHandler
  });

  const searchRequestIdRef = useRef(searchRequestId);
  useEffect(() => {
    searchRequestIdRef.current = searchRequestId;
  }, [searchRequestId]);

  useEffect(() => {
    trackEvent('Zero Results Shown', {
      searchRequestId: searchRequestIdRef.current
    });

    datadogRum.addAction('Zero Results Shown');
  }, [trackEvent]);

  return (
    <>
      {experimentBucket === 'show-zero-counts' ? (
        <div className="bg-white flex flex-col gap-16 items-center justify-center mb-16 p-24 m:gap-24">
          <div className="flex flex-col gap-8 items-center justify-center m:gap-12">
            <div className="t-header-m text-blue-7 m:t-header-xl">
              No exact matches
            </div>
            <div className="t-body-m text-blue-7 text-center m:t-body-l">
              Save your search to get notified when more matches are available.
            </div>
          </div>
          <PrimaryButton
            className="!h-[40px] !min-h-[40px] max-w-[300px] w-full"
            data-analytics-id="zero results notify me button"
            onClick={handleOpenModal}
          >
            Save Search
          </PrimaryButton>
        </div>
      ) : (
        <NoResultsWrapper>
          <Title>We didn’t find any exact matches</Title>
          <SubTitle>
            We get more cars every day. Get notified when the one you’re looking
            for is available.
          </SubTitle>
          <CtaWrapper>
            <NotifyButton
              data-analytics-id="zero results notify me button"
              onClick={handleOpenModal}
            >
              Email me when available
            </NotifyButton>
          </CtaWrapper>
        </NoResultsWrapper>
      )}
      <SimilarResultsSection />
    </>
  );
}
